import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';

import { ROUTES } from 'constants/routes';

import IconButton from './layout';

class IconButtonContainer extends Component {
  handleClick = () =>
    this.props.dispatch(
      push({
        pathname: ROUTES.ENERGY_ADVISOR_TIPS,
        params: this.props.tipParams
      })
    );

  render() {
    return <IconButton {...this.props} onClick={this.handleClick} />;
  }
}

IconButtonContainer.propTypes = {
  tipParams: PropTypes.shape({
    placeId: PropTypes.number.isRequired,
    placeText: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired
  }).isRequired
};

export default connect()(IconButtonContainer);
